import { LoyaltyProgramId } from '@/views/checkout/components/payment-methods/payment-card/constants/loyalty-program-id';

export const Nbg = () => import('./nbg-program');
export const Alpha = () => import('./alpha-program');
export const Eurobank = () => import('./eurobank-program');

export function getLoyaltyProgramComponent(programId?: number) {
    switch (programId) {
        case LoyaltyProgramId.NbgGo4More:
            return Nbg;
        case LoyaltyProgramId.AlphaLoyalty:
            return Alpha;
        case LoyaltyProgramId.EurobankEpistrofi:
            return Eurobank;
        default:
            return null;
    }
}

export function getLoyaltyProgramIcon(programId?: number) {
    switch (programId) {
        case LoyaltyProgramId.NbgGo4More:
            return 'nbg';
        case LoyaltyProgramId.AlphaLoyalty:
            return 'alpha';
        case LoyaltyProgramId.EurobankEpistrofi:
            return 'eurobank';
        default:
            return '';
    }
}
